import useSWR from 'swr';

import { serviceProvidersRetrieve } from '~/data/generated/endpoints/service-providers/service-providers';
import { parseApiResponse } from '~/data/parseApiResponse';
import { serviceProviderSchema } from '~/data/schemas/serviceProvider';

const serviceProviderFetcher = async (serviceProviderId: string) => {
  const { data } = await serviceProvidersRetrieve(serviceProviderId);
  return parseApiResponse(serviceProviderSchema, data, 'ServiceProvider');
};

export const useServiceProvider = (serviceProviderId: string | null) => {
  const { data, error, isLoading } = useSWR(
    serviceProviderId ? ['serviceProvider', serviceProviderId] : null,
    () => serviceProviderFetcher(serviceProviderId as string),
  );

  return { data, error, isLoading };
};
